import React from 'react';
import { Link } from 'react-router-dom';
import Menu from 'antd/lib/menu';
import _ from 'lodash';

import goldRoute from 'modules/Gold/route';
import { permissionService } from 'shared/services';
import GoldIcon from '../../assets/Gold.icon';

const { SubMenu } = Menu;
const { checkPermission } = permissionService;

const goldMenu = (location, onLink) => {
  const pathname = _.get(location, 'pathname', '');
  let transactionLog;

  if (pathname.includes(goldRoute.TRANSACTION_LOG)) {
    transactionLog = pathname;
  }

  return (
    <SubMenu
      key="gold"
      title={
        <span className="center-content">
          <GoldIcon />
          <span>eMAS</span>
        </span>
      }
    >
      {checkPermission('Transaction Log:read', true) && (
        <Menu.Item key={transactionLog}>
          <Link to={goldRoute.TRANSACTION_LOG} onClick={onLink}>
            <span>Transaction Log</span>
          </Link>
        </Menu.Item>
      )}
    </SubMenu>
  );
};

export default goldMenu;
